const formatText = (text, taggableUsers, transform) => {
    const taggedUsers = text.match(/{(.*?)}/g);
    taggedUsers === null || taggedUsers === void 0 ? void 0 : taggedUsers.forEach(taggedUser => {
        var _a;
        const guidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g;
        const userId = (_a = taggedUser.match(guidRegex)) === null || _a === void 0 ? void 0 : _a[0];
        const user = taggableUsers === null || taggableUsers === void 0 ? void 0 : taggableUsers.find(user => user.id === userId);
        if (user) {
            const replacement = transform(user);
            text = text === null || text === void 0 ? void 0 : text.replace(taggedUser, replacement);
        }
    });
    return text;
};
export const formatTagsToMentions = (text, taggableUsers) => {
    return formatText(text, taggableUsers, (user) => {
        return `{uid:${user.id}[${user.name}]}`;
    });
};
export const formatTagsToHTML = (text, taggableUsers) => {
    return formatText(text, taggableUsers, (user) => {
        return `<span class='mention'>@${user.name}</span>`;
    });
};
